import { useGlobalContentStore } from '~/store/globalContent';
import { PriceInfo } from '#constants/types/algolia';

export default function usePrices() {
  const globalContent = useGlobalContentStore();

  const productPrice = (priceInfo: PriceInfo|undefined, type: 'price'|'priceBeforeDiscount'|'recommendedPrice'|'subtotal' = 'price', display: boolean = true): string|undefined => {
    if (!priceInfo) {
      return 'N/A';
    }
    if (globalContent.getDisplayIncVat) {
      return priceInfo[`${type}${display ? 'Display' : ''}`];
    }
    return priceInfo[`${type}BeforeVat${display ? 'Display' : ''}`];
  };

  return {
    productPrice,
  };
}
